import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { adminGetDashboardVenuesStatsDataApi } from '../../../api/dashboard/adminGetDashboardVenuesStatsDataApi';
import { AdminDashboardDataFilter, AdminDashboardVenuesStatsResponse } from '../../../graphql/API';

export const useAdminGetDashboardVenuesStatsDataQuery = (
  filter: AdminDashboardDataFilter,
): UseQueryResult<AdminDashboardVenuesStatsResponse, Error> => {
  const adminGetDashboardVenuesStatsDataQuery = useQuery({
    queryKey: ['admin-get-dashboard-venues-stats-data', filter],
    queryFn: async ({ queryKey }) => {
      const [, filter] = queryKey as [string, AdminDashboardDataFilter];
      const response = await adminGetDashboardVenuesStatsDataApi(filter);
      return response;
    },
  });
  return { ...adminGetDashboardVenuesStatsDataQuery };
};
